import { IInfoWidgetBaseConfig } from 'src/app/pages/service/pages/account-page/interface/info-widget.interface';
import { ITicketEventComplement } from '../interface/ticket-event.model';
import { FV_CHIP_COLORS } from '@discocil/fv-components';
import { INFO_WIDGET_OPTION_TYPE } from 'src/app/pages/service/pages/account-page/enum/info-widget-option.enum';

export function formatComplementAsInfoWidget(
  complement: ITicketEventComplement
): IInfoWidgetBaseConfig {
  const remaining = complement.productQuantity - complement.productConsumed;
  const isDisabled = remaining === 0;

  return {
    id: complement._id,
    chips: [
      {
        title: `${complement.productConsumed} / ${complement.productQuantity}`,
        color: FV_CHIP_COLORS.zinc,
      },
    ],
    title: complement.label,
    showCheckbox: false,
    icon: 'far fa-glass-martini-alt',
    isDisabled,
    showBorder: false,
    type: INFO_WIDGET_OPTION_TYPE.complement,
  };
}
